import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';

export class WebSocketUtils {
  public static getWebSocketConfiguration(socketRelativePath?: string): InjectableRxStompConfig {
    const socketPath = socketRelativePath || '/ws/socket/ordering/websocket';
    const wsOrigin = new URLSearchParams(window.location.search).get('wsOrigin');
    const origin = wsOrigin || window.location.origin;
    const protocol = origin.startsWith('https') ? 'wss://' : 'ws://';
    const host = origin.replace(/^https?:\/\//, '');
    return {
      brokerURL: `${protocol}${host}${socketPath}`,
      heartbeatIncoming: 0,
      heartbeatOutgoing: 20000,
      reconnectDelay: 200,
    };
  }
}
